'use client';

import React, { createContext, useContext, type PropsWithChildren } from 'react';
import { useSingleDropdown, type Action, type DropdownState } from './useSingleDropdown';

export type DropdownContextType = {
  state: DropdownState;
  dispatch: React.Dispatch<Action>;
};

export const DropdownContext = createContext<DropdownContextType | undefined>(undefined);

type DropdownProviderProps = PropsWithChildren;

export function DropdownProvider({ children }: DropdownProviderProps) {
  const [state, dispatch] = useSingleDropdown();

  return (
    <DropdownContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </DropdownContext.Provider>
  );
}

export function useDropdownContext() {
  const dropdownContext = useContext(DropdownContext);
  if (dropdownContext === undefined) {
    throw new Error('useDropdownContext must be used within a DropdownProvider');
  }
  return dropdownContext;
}
